export default class DateTimeUtil {
    static diff(sooner, later) {
        return later.getTime() - sooner.getTime();
    }
    static diffDays(sooner, later) {
        return DateTimeUtil.toDays(DateTimeUtil.diff(sooner, later));
    }
    static toHours(millisecs) {
        return millisecs / 1000 / 3600;
    }
    static toDays(millisecs) {
        return this.toHours(millisecs) / 24;
    }
    static addHours(time, hours) {
        return DateTimeUtil.addMilliSecs(time, 60 * 60 * 1000 * hours);
    }
    static addDays(time, days) {
        return DateTimeUtil.addHours(time, 24 * days);
    }
    static addMilliSecs(time, millisecs) {
        const t = time.getTime() + millisecs;
        return new Date(t);
    }
    static startOfDay(time) { return new Date(time.getFullYear(), time.getMonth(), time.getDate()); }
    static allDaysBetween(first, last) {
        const currentDate = new Date(first.getFullYear(), first.getMonth(), first.getDate()), result = [];
        while (currentDate < last) {
            result.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1); //funkar!
        }
        return result;
    }
    static allHoursBetween(first, last) {
        let currentHour = new Date(first.getFullYear(), first.getMonth(), first.getDate(), first.getHours()), result = [];
        while (currentHour < last) {
            result.push(new Date(currentHour));
            currentHour = this.addMilliSecs(currentHour, 3600 * 1000);
        }
        return result;
    }
}
